// Canales de contacto oficiales de MiPAE. Centralizados acá para mantener
// consistencia en toda la app y evitar el enredo de dominios (.cl vs .app).

export const CONTACTO_EMAIL = 'contacto@mipae.cl';

// ── WhatsApp de Sebastián ────────────────────────────────────────────────────
// Historia, para no volver a dar vueltas: el número estuvo en la app y en los
// correos desde el 2026-06-02 ("Respondo yo"), salió de todos los contactos el
// 2026-09-29 a pedido de Sebastián y el 2026-10-17 también salió el ícono
// "próximamente" del pie. El 2026-10-30 Sebastián pidió publicarlo de nuevo
// como contacto directo: una persona que quería conocer MiPAE no encontró cómo
// escribirnos. Es su WhatsApp PERSONAL, el mismo número de siempre (el único
// real en el historial del repo; los otros que aparecen son ejemplos de las
// pruebas de datos personales).
//
// Reglas de este canal:
// - El enlace abre la conversación con un mensaje que la persona puede editar
//   y que NO se envía solo (así funciona wa.me con ?text=).
// - El mensaje es fijo por motivo. Jamás se le agrega nada de la cuenta, del
//   uso de la app ni de un paciente.
// - Ninguna superficie promete atención inmediata ni disponibilidad: responde
//   una persona cuando puede.
// - Las pantallas piden no mandar datos ni fotos de pacientes por aquí, que es
//   un canal que MiPAE no controla (el motivo del retiro del 2026-10-17).
//
// Kill-switch REACT_APP_WHATSAPP_CONTACTO_ENABLED (ON por defecto): si Sebastián
// quiere retirarlo otra vez, 'false' lo saca de todas las superficies y queda
// el correo.
export const WHATSAPP_NUMERO = '56956735704'; // formato wa.me: sin +, sin espacios
export const WHATSAPP_VISIBLE = '+56 9 5673 5704';

export const whatsappDisponible = () => process.env.REACT_APP_WHATSAPP_CONTACTO_ENABLED !== 'false';

// Un mensaje por motivo, con las palabras que eligió Sebastián.
export const MENSAJES_WHATSAPP = Object.freeze({
  general: 'Hola, Sebastián. Quisiera conocer más sobre MiPAE',
  institucional: 'Hola, Sebastián. Me interesa conversar sobre MiPAE para mi institución',
  ayuda: 'Hola, necesito ayuda con MiPAE',
});

// El único constructor del enlace. Un motivo desconocido cae al general:
// nunca se arma un mensaje con texto que no esté en el catálogo.
export function enlaceWhatsApp(motivo = 'general') {
  const texto = MENSAJES_WHATSAPP[motivo] || MENSAJES_WHATSAPP.general;
  return `https://wa.me/${WHATSAPP_NUMERO}?text=${encodeURIComponent(texto)}`;
}

// ── Clics de contacto (telemetría) ───────────────────────────────────────────
// Se mide que alguien TOCÓ un canal y desde dónde, nada más: un clic en
// WhatsApp no es una conversación recibida ni una venta. Jamás viaja el número
// ni el mensaje. Catálogo cerrado `<canal>_<ubicacion>`; sin sesión va a
// eventos_anonimos (evento 'contacto_cta', mismo catálogo en
// api/track-landing.js y en el CHECK de la tabla) y con sesión a eventos_v2
// (evento 'contacto_clic' con canal y ubicación en el payload).
//   contacto       página Contacto, bloque "Quiero conocer MiPAE"
//   ayuda          página Contacto, bloque "Ya uso MiPAE y necesito ayuda"
//   instituciones  página Para instituciones y su bloque en Contacto
//   portada        sección "MiPAE para instituciones" de la portada
//   pie            redes del pie (inicio y ¿Qué es MiPAE?)
//   flotante       botón flotante de la web pública
export const CTAS_CONTACTO = Object.freeze([
  'whatsapp_contacto', 'whatsapp_ayuda', 'whatsapp_instituciones', 'whatsapp_portada',
  'whatsapp_pie', 'whatsapp_flotante',
  'correo_contacto', 'correo_ayuda', 'correo_instituciones', 'correo_portada', 'correo_pie',
]);

// Las redes de MiPAE que se muestran en el pie (SocialBar). Decisión de
// Sebastián del 2026-10-17 ("con los colores se ve infantil"): sin TikTok, en
// el gris de la tinta. Una red sin dirección NO se muestra: un ícono que no
// lleva a ningún lado se lee como roto. WhatsApp no es una red de MiPAE sino
// el contacto directo con Sebastián, así que no vive en esta lista: SocialBar
// lo suma aparte con enlaceWhatsApp.
export const REDES_MIPAE = Object.freeze([
  { id: 'instagram', nombre: 'Instagram', url: 'https://www.instagram.com/mipae.cl/' },
  // La dirección directa de la página: el enlace de "compartir" que pasó
  // Sebastián (facebook.com/share/1EsjQ4P1rF) redirige aquí con datos de
  // seguimiento en la URL.
  { id: 'facebook', nombre: 'Facebook', url: 'https://www.facebook.com/profile.php?id=61567766684678' },
  { id: 'linkedin', nombre: 'LinkedIn', url: 'https://www.linkedin.com/company/mipae-cl/' },
]);
